/* eslint-disable global-require, no-underscore-dangle, no-param-reassign, no-void, no-shadow */
/* eslint-disable func-names */

const eventing = require('../../helpers/eventing');
const uuid = require('uuid');

module.exports = function SinglePeerConnectionFactory() {
  return function SinglePeerConnection(options, controller) {
    const _transceivers = {};
    const _tracks = [];
    let _iceConnectedEmitted = false;

    this._id = uuid();

    // SPC events wrapper for PeerConnection

    const _onIceConnected = () => {
      this.trigger('iceConnected');
      _iceConnectedEmitted = true;
    };
    const _onClosed = () => this.trigger('close');
    const _onRemoteVideoSupported = supported => this.trigger('remoteVideoSupported', supported);
    const _onPeerError = ({ reason, prefix }) => this.trigger('error', reason, prefix);
    const _onIceConnectionStateChange = state => this.trigger('iceConnectionStateChange', state);
    const _onSignalingStateChange = state => this.trigger('signalingStateChange', state);
    const _onSignalingStateStable = state => this.trigger('signalingStateStable', state);

    eventing(this);

    const _peerConnection = controller.getPeerConnection(options, this);

    _peerConnection.on({
      iceConnected: _onIceConnected,
      close: _onClosed,
      signalingStateChange: _onSignalingStateChange,
      signalingStateStable: _onSignalingStateStable,
      error: _onPeerError,
      qos: qos => this.trigger('qos', qos),
      iceConnectionStateChange: _onIceConnectionStateChange,
      remoteVideoSupported: _onRemoteVideoSupported,
    }, this);

    // Specific SPC logic

    const shouldEmitIceConnected = () => _peerConnection.iceConnectionStateIsConnected() &&
     !_iceConnectedEmitted;

    this._onTrackAdded = (remoteRTCStream) => {
      const { track, transceiver } = remoteRTCStream;
      _transceivers[track.id] = transceiver.mid;
      _tracks.push(track.id);
      if (shouldEmitIceConnected()) {
        // Since PC is already connected, we will need to emit the event now.
        _onIceConnected();
      }
      this.trigger('trackAdded', remoteRTCStream);
    };

    this.disconnect = () => {
      controller.removeSinglePeerConnection(this._id);
      _peerConnection.stopTransceivers(Object.values(_transceivers));
    };

    this.removeTrack = (track) => {
      if (_transceivers[track.id]) {
        _peerConnection.stopTransceivers([_transceivers[track.id]]);
      }
      const trackIndex = _tracks.indexOf(track.id);
      if (trackIndex > -1) {
        _tracks.splice(trackIndex, 1);
      }
      controller.removeTrack(track, this._id);
    };

    this.remoteTracks = () => _tracks;

    // SPC wrapper for PeerConnection

    this.getDataChannel = (label, options, completion) => {
      _peerConnection.getDataChannel(label, options, completion);
    };

    this.getSourceStreamId = () => _peerConnection.getSourceStreamId();

    this.processMessage = (type, message) => {
      _peerConnection.processMessage(type, message);
    };

    this.remoteDescription = () => _peerConnection.remoteDescription();

    this.getStats = (callback) => {
      _peerConnection.getStats(callback);
    };

    this.getSynchronizationSources = (callback) => {
      _peerConnection.getSynchronizationSources(callback);
    };

    this.getRtcStatsReport = (callback) => {
      _peerConnection.getRtcStatsReport(callback);
    };

    this.remoteStreams = () => _peerConnection.remoteStreams();

    this.hasRelayCandidates = () => _peerConnection.hasRelayCandidates();

    this.iceRestart = () => _peerConnection.iceRestart();

    this.iceConnectionStateIsConnected = () => _peerConnection.iceConnectionStateIsConnected();
  };
};
